import { render } from "./HeroiconsOutlinePhoneIncoming.vue?vue&type=template&id=35fc04e4"
const script = {}

import exportComponent from "/Users/mior/Projects/laravel/nova/silver-surfer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePhoneIncoming.vue"]])

export default __exports__